// src/mixins/SetPlaceholderMixin.js
export default {
  mounted () {
    this.setPlaceholder()
  },
  methods: {
    setPlaceholder () {
      this.$nextTick(() => {
        if (this.$el && typeof this.$el.querySelector === 'function') {
          const inputElement = this.$el.querySelector('.input-search.vs-table--search-input')
          if (inputElement) {
            inputElement.placeholder = 'Search...'
          }
          const buttonElement = this.$el.querySelector('.items-per-page-handler')
          if (buttonElement) {
            const spanElement = buttonElement.querySelector('.mr-2')
            if (spanElement && !buttonElement.querySelector('.invoice-view-title-text')) {
              const newSpan = document.createElement('span')
              newSpan.className = 'mr-2 invoice-view-title-text'
              newSpan.textContent = 'Showing:'
              spanElement.parentNode.insertBefore(newSpan, spanElement)
            }
          }
        }
      })
    }
  },
  beforeDestroy () {
    // Optional: Clean up if needed
  }
}
  